/* jshint esversion: 6 */
import React from 'react';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ThumbnailList from 'app/components/PostingTool/Accessories/ThumbnailList.jsx';

class ImageEditorControls extends React.Component {
    render() {
        let altTextField = null;

        if (this.props.selectedImage !== '') {
            let imageData = this.props.imageData.find((media) => { return media.hash === this.props.selectedImage});

            if (imageData && this.props.hasMediaFieldSupport('alt_text')) {
                if (imageData.type.match(/image/)) {
                    let altText = (this.props.alt_text[this.props.selectedImage] !== undefined) ? this.props.alt_text[this.props.selectedImage] : '';
                    altTextField = (
                        <div className="pt-service-field">
                            <div className="pt-field-label">Alt Text</div>
                            <UncontrolledTextInput
                                className={`text-input large`}
                                value={altText}
                                name={'alt_text'}
                                onChange={this.props.onAltTextChange}/>
                        </div>
                    );
                }
            }
        }

        return (
            <div>
                 <div className="image-editor-display">
                    <div className="image-editor-wrapper">
                        <ThumbnailList
                            {...this.props}
                            container="image-editor-wrapper"/>
                    </div>
                </div>
                <div className="pt-service-fields">
                    {altTextField}
                </div>
            </div>
        );
    }
}

ImageEditorControls.displayName = "ImageEditorControls";
export default ImageEditorControls;
